// Public API for taskManagement feature module

// Hooks
export { useChildRecurrenceNotice } from './hooks/useChildRecurrenceNotice'
export { useReminderDelivery, useReminderPlan } from './hooks/useReminderDelivery'

// Pages
export { DormantPage } from './pages/DormantPage'
export { DonePage } from './pages/DonePage'
export { RecurringPage } from './pages/RecurringPage'
export { requestRecurringCreate } from './pages/RecurringPage/recurringCreateRequest'
export { ProjectPage } from './pages/ProjectPage'

// Components
export { TaskCheck } from './components/TaskCheck'
export type { TaskCheckProps, TaskCheckKind, TaskCheckVariant } from './components/TaskCheck'
export { TaskEntry } from './components/TaskEntry'
export type { TaskEntryProps, TaskEntryData, TaskEntryMode, TaskCreationData, TaskEntryActions } from './components/TaskEntry'
export { QuickAddCard } from './components/QuickAddCard'
export type { QuickAddCardProps } from './components/QuickAddCard'
export { toCreateTask } from './utils/toCreateTask'
export { cascadeDescription } from './utils/cascadeDescription'
export { dropdownLayerOpen, targetInDropdownLayer } from './components/TaskEntry/dropdownLayer'
export { TaskDropdownBelowTrigger } from './components/TaskDropdown'
export { useQuickAddSession } from './hooks/useQuickAddSession'
export type { QuickAddSessionOptions, QuickAddCreated } from './hooks/useQuickAddSession'
export { useQuickAddCreatedToast } from './hooks/useQuickAddCreatedToast'
export { useQuickAddReveal } from './hooks/useQuickAddReveal'
export { QuickAddDialog } from './components/QuickAddDialog'
export type { QuickAddDialogProps } from './components/QuickAddDialog'
export { TaskList } from './components/TaskList'
export type { TaskListProps } from './components/TaskList'

// Einführung (#323): Beispielprojekt, Lernaufgaben, Angebot — das MainLayout startet sie.
export { useIntroStart } from './intro'

// Testdaten (#269): `npm run testdata` lädt den Erzeuger nach, damit er nicht im App-Bündel steckt; Einstellungen
// und Hilfe-Menü gehen über den Kontext aus `lib/testData`.
export const loadTestData = () => import('./testData')
export { TestDataActionsProvider } from './testData/TestDataActionsProvider'
